import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "burger"]

  connect() {
    this.onKeydown = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
    document.body.style.overflow = ""
  }

  open() {
    this.panelTarget.classList.add("is-open")
    this.panelTarget.setAttribute("aria-hidden", "false")
    if (this.hasBurgerTarget) this.burgerTarget.setAttribute("aria-expanded", "true")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.panelTarget.classList.remove("is-open")
    this.panelTarget.setAttribute("aria-hidden", "true")
    if (this.hasBurgerTarget) this.burgerTarget.setAttribute("aria-expanded", "false")
    document.body.style.overflow = ""
  }
}
